import React, { FunctionComponent } from 'react';
import Divider from '@Components/Divider/Divider';
import Icon from '@Components/Icon/Icon';
import { BodyM, Title } from '@Components/Typography/Typography.styled';
import useTranslate from '@Utils/hooks/useTranslate';
import { ButtonContent } from './CheckoutSummary.styled';
import { SecondaryLargeButtonFixed } from '@Components/controls/Button/Button';
import ConditionalRender from '@Components/ConditionalRender/ConditionalRender';

interface ISubmissionFailedSummaryProps {
	backToStore: () => void;
	exceptionDescription: string;
	iconSize: number;
}

const SubmissionFailedSummary: FunctionComponent<ISubmissionFailedSummaryProps> = ({
	backToStore,
	exceptionDescription,
	iconSize,
}) => {
	const { translate } = useTranslate();

	return (
		<>
			<Icon height={iconSize} width={iconSize} fill="warning" name="error" />
			<Divider color="transparent" marginBottom={16} />
			<Title color="warning">{translate(`checkout-summary.payment.SUBMISSION_FAILED.title`)}</Title>
			<ConditionalRender
				show={exceptionDescription.length !== 0}
				onTrue={() => {
					return (
						<>
							<Divider color="transparent" marginBottom={16} />{' '}
							<BodyM color="black87">{exceptionDescription}</BodyM>
						</>
					);
				}}
				onFalse={() => {
					return (
						<>
							<Divider color="transparent" marginBottom={16} />{' '}
							<BodyM color="black87">{translate('checkout-summary.submission.failed.discription')}</BodyM>
						</>
					);
				}}
			/>
			<Divider color="transparent" marginBottom={16} />
			<ButtonContent>
				<SecondaryLargeButtonFixed uniqueId="success.payment.back.to.store" onClick={backToStore}>
					{translate('checkout-summary.success.payment.back.to.store')}
				</SecondaryLargeButtonFixed>
			</ButtonContent>
		</>
	);
};

export default SubmissionFailedSummary;
